/*!
 * @license
 * Copyright © 2005-2024 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { BaseApi } from './base.api';
import { throwIfNotDefined } from '../../../assert';
export class IntegrationBoxApi extends BaseApi {
    confirmAuthorisation() {
        return this.get({
            path: '/api/enterprise/integration/box/confirm-auth-request',
            accepts: ['text/html']
        });
    }
    createRepositoryAccount(userId, credentials) {
        throwIfNotDefined(userId, 'userId');
        throwIfNotDefined(credentials, 'credentials');
        const pathParams = {
            userId
        };
        return this.post({
            path: '/api/enterprise/integration/box/{userId}/account',
            pathParams,
            bodyParam: credentials
        });
    }
    deleteRepositoryAccount(userId) {
        throwIfNotDefined(userId, 'userId');
        const pathParams = {
            userId
        };
        const accepts = ['*/*'];
        return this.delete({
            path: '/api/enterprise/integration/box/{userId}/account',
            pathParams,
            accepts
        });
    }
    getBoxPluginStatus() {
        return this.get({
            path: '/api/enterprise/integration/box/status',
            accepts: ['*/*']
        });
    }
    getFiles(opts) {
        opts = opts || {};
        return this.get({
            path: '/api/enterprise/integration/box/files',
            queryParams: opts,
            accepts: ['*/*']
        });
    }
    getRepositoryAccount(userId) {
        throwIfNotDefined(userId, 'userId');
        const pathParams = {
            userId
        };
        return this.get({
            path: '/api/enterprise/integration/box/{userId}/account',
            pathParams,
            accepts: ['*/*']
        });
    }
    updateRepositoryAccount(userId, credentials) {
        throwIfNotDefined(userId, 'userId');
        throwIfNotDefined(credentials, 'credentials');
        const pathParams = {
            userId
        };
        return this.put({
            path: '/api/enterprise/integration/box/{userId}/account',
            pathParams,
            bodyParam: credentials,
            accepts: ['*/*']
        });
    }
}
